export default __webpack_public_path__ + "static/media/leather_웹.e3eaf138.jpg";